import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { FAQ } from "./component";

const mapStateToProps = (_: IStoreState) => ({});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FAQConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedFAQ = connector(withRouter(FAQ));
